'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var dom = {
  modalTrigger: 'data-trigger-country-selector-modal',
  modal: 'data-country-selector-modal',
  relocation: 'data-relocation-modal',
  close: 'data-close-country-selector-modal',
  backdrop: 'data-country-selector-modal-backdrop',
  modalContents: 'data-country-selector-modal-contents',
  form: '.shopify-localization-form',
  formSelect: 'data-country-selector-form-select',
  formSubmit: 'data-country-selector-form-submit'
};

var cache = {};

var checkCloseModal = function checkCloseModal(event) {
  if (event.keyCode === 27) {
    closeModal();
  }
};
var closeModal = function closeModal() {
  if (cache.modal !== false) {
    cache.modal.classList.remove('active');
    cache.relocation.classList.remove('active');
  }
};
var openModal = function openModal(event) {
  if (cache.modal !== false) {
    cache.modal.classList.add('active');
  }
};

var getFlagEmoji = function getFlagEmoji(countryCode) {
  var codePoints = countryCode.toUpperCase().split('').map(function (char) {
    return 127397 + char.charCodeAt();
  });
  return String.fromCodePoint.apply(String, (0, _toConsumableArray3.default)(codePoints));
};
var setCountryFlagEmoji = function setCountryFlagEmoji() {
  var countryIsoCode = document.querySelector('[' + dom.modalTrigger + ']').getAttribute('data-countrycode');
  document.querySelector('[' + dom.modalTrigger + '] .flag').innerHTML = getFlagEmoji(countryIsoCode);
};

var relocationContent = function relocationContent(country) {
  var defaultSite = window.theme.strings.defaultURL,
      stores = window.theme.strings.general.stores,
      recommendedStore = stores.filter(function (el) {
    return el.country == country;
  }) || defaultSite,
      link = document.querySelector('.relocation-btn'),
      text = document.querySelector('[data-change-location-link]');
  if (!link || !text) return;

  link.setAttribute('href', recommendedStore[0].url);
  text.textContent = recommendedStore[0].url.replace('https://', '');
};

var getCountry = function getCountry() {
  var currentCountry = window.Cookies.get('zCountry') || window.Cookies.get('_shopify_country'),
      countriesArray = window.theme.strings.general.stores.map(function (el) {
    return el.country;
  }),
      currentSite = window.location.href,
      firstVisit = window.sessionStorage.getItem('relocation');

  if (countriesArray.includes(currentCountry) && !currentSite.includes(currentCountry) && !firstVisit) {
    if (cache.relocation !== false) {
      cache.relocation.classList.add('active');
      window.sessionStorage.setItem('relocation', 'true');
      relocationContent(currentCountry);
    }
  }
};

var bindUiActions = function bindUiActions() {

  // show flags
  document.querySelectorAll('[' + dom.formSelect + '].show-flags option').forEach(function (option) {
    var optionValue = option.value,
        optionText = option.text;
    document.querySelector('[' + dom.formSelect + '].show-flags option[value="' + optionValue + '"]').text = optionText.replace('[FLAG]', getFlagEmoji(optionValue));
  });

  // modal actions
  var triggers = document.querySelectorAll('[' + dom.modalTrigger + ']');
  triggers.forEach(function (trigger) {
    trigger.addEventListener('click', openModal);
  });
  var closeModalButtons = document.querySelectorAll('[' + dom.close + ']');
  closeModalButtons.forEach(function (closeButton) {
    closeButton.addEventListener('click', closeModal);
  });
  document.addEventListener('keydown', checkCloseModal);
  if (cache.backdrop) {
    cache.backdrop.addEventListener('click', closeModal);
  }

  // form actions
  var localizationFormSubmit = function localizationFormSubmit(event) {
    event.target.form.submit();
  };
  var localizationSelectboxes = document.querySelectorAll('[' + dom.formSelect + ']');
  localizationSelectboxes.forEach(function (element) {
    element.addEventListener('change', localizationFormSubmit);
  });
};

var setup = function setup() {

  // cache common modal elements
  cache.modalTrigger = document.querySelector('[' + dom.modalTrigger + ']') || false;
  cache.relocation = document.querySelector('[' + dom.relocation + ']') || false;
  cache.modal = document.querySelector('[' + dom.modal + ']') || false;
  cache.close = document.querySelector('[' + dom.close + ']') || false;
  cache.backdrop = document.querySelector('[' + dom.backdrop + ']') || false;
  cache.modalContents = document.querySelector('[' + dom.modalContents + ']') || false;
  cache.form = document.querySelector('' + dom.form) || false;
  cache.formSelect = document.querySelector('[' + dom.formSelect + ']') || false;
  cache.formSubmit = document.querySelector('[' + dom.formSubmit + ']') || false;

  bindUiActions();

  setCountryFlagEmoji();

  getCountry();
};

exports.default = {
  setup: setup
};